import UserGroup from '@app/src/components/Ui/UserGroup'

import type { User } from '@app/src/types/resourceExplorer'

import React from 'react'

import ParentCellOrFragment from './ParentCellOrFragment'
import type { UserCellProps } from './UserCell'
import UserCell from './UserCell'
import { useDrawer } from '@app/src/components/Drawer/DrawerContext'
import DrawerViewUserGroup from '@app/src/components/Drawer/Views/DrawerViewUserGroup'

type UserGroupCellProps = {
  users?: User[]
  disableCell?: boolean
  groupSize?: number
  label?: string
  title?: string
  onClick?: () => void
} & Omit<UserCellProps, 'user' | 'disableCell'>

const UserGroupCell: React.FC<UserGroupCellProps> = ({
  users,
  disableCell,
  groupSize = 3,
  label,
  title,
  onClick,
  ...userCellProps
}) => {
  const { openDrawer } = useDrawer()

  // When there's exactly one user, render UserCell directly with drawer enabled
  if (users?.length === 1) {
    // Omit subTitle since it doesn't make sense in the single-user drawer context
    const { subTitle, ...restUserCellProps } = userCellProps
    return <UserCell user={users[0]} disableCell={disableCell} drawer {...restUserCellProps} />
  }

  // For multiple users: if title is provided, auto-generate onClick to open DrawerViewUserGroup
  const handleClick =
    title && users && users.length > 1 ? () => openDrawer(<DrawerViewUserGroup title={title} users={users} />) : onClick

  // For 0 or multiple users, use the existing UserGroup component
  return (
    <ParentCellOrFragment disableCell={disableCell}>
      <UserGroup users={users} max={groupSize} label={label} onClick={handleClick} />
    </ParentCellOrFragment>
  )
}

export default UserGroupCell
